//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

import React from "react";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
var HelpButton = function HelpButton(_ref) {
  var url = _ref.url;
  var handleClick = function handleClick() {
    var navigationUrl = url ? url : "https://support.emerald-associates.com/portal/en/home";
    window.open(navigationUrl, "_blank");
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: "Help"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(HelpIcon, null)));
};
export default HelpButton;